import SJCheckbox from '@/components/SJCheckbox'
import SJFormItem from '@/components/SJFormItem'
import SJNoData from '@/components/SJNoData'
import SJRadio from '@/components/SJRadio'
import SJButton from '@/components/SJButton'
import SJImageCell from '@/components/SJImageCell'
import SJCard from '@/components/SJCard'
import SJCell from '@/components/SJCell'
import { PullToRefresh, List, InfiniteScroll } from 'antd-mobile'
import { sleep } from 'antd-mobile/es/utils/sleep'
import { useState } from 'react'

const Demo = () => {
  const [count, setCount] = useState(0)
  const [data, setData] = useState(() => getNextData())
  const [hasMore, setHasMore] = useState(true)
  const [focus, setFocus] = useState(false)

  const loadMore = async () => {
    await sleep(1000)
    setData([...getNextData(), ...data])
    setCount(count + 1)
    if (count > 3) {
      setHasMore(false)
    }
  }
  return (
    <div className="page demo">
      <PullToRefresh onRefresh={loadMore}>
        <div style={{ padding: '0 20px' }}>
          <div className="h1">Demo</div>
          <SJButton size="large" type="primary">
            你好
          </SJButton>
          <SJButton size="large">你好</SJButton>
          <SJButton type="danger">你好</SJButton>
          <SJButton disabled>你好</SJButton>
          <SJImageCell image="" name="棋手" role="管理员"></SJImageCell>
          <SJCard>
            <SJCell title="我的订单" indicator></SJCell>
            <SJCell title="我的优惠券" indicator detail="20张"></SJCell>
          </SJCard>
          <div className="flex">
            <SJRadio checked={true} title={'选项1'}></SJRadio>
            <SJRadio checked={false} title={'选项2'}></SJRadio>
            <SJRadio checked={false} title={'选项3'}></SJRadio>
          </div>
          <div className="flex">
            <SJCheckbox checked={true} onChange={() => {}} title="我已阅读并同意"></SJCheckbox>
            <SJCheckbox checked={false} onChange={() => {}} title="我已阅读并同意"></SJCheckbox>
          </div>
          <SJNoData />
          <SJFormItem
            title="证件号码"
            titleWidth="75px"
            focus={focus}
            // status={"error"}
            // statusText="证件号码有误，请重新填写"
          >
            <input
              className="sc-form-item_input"
              placeholder="请输入证件号码"
              onInput={() => {}}
              onFocus={() => setFocus(true)}
              onBlur={() => setFocus(false)}
              value={''}
            />
          </SJFormItem>
        </div>
        <List style={{ minHeight: '100vh' }}>
          {data.map((item: any, index: number) => (
            <List.Item key={index}>{item}</List.Item>
          ))}
        </List>
        <InfiniteScroll loadMore={loadMore} hasMore={hasMore} />
      </PullToRefresh>
    </div>
  )
}

const getNextData = () => {
  const ret: string[] = []
  for (let i = 0; i < 18; i++) {
    ret.unshift('123')
  }
  return ret
}

export default Demo
